/**
 * To use this plugin, include it with Vue.use().
 * Use
 * 		<feature :id="$mhi.FEATURE"></feature>
 * to wrap a feature component.
 * The <feature> tag cannot be the first item rendered or it will throw an error
 * saying that multiple root nodes were returned from the render function.
 *
 * To check if user has feature inside a component, you can use a statement like this:
 * 		if (this.$mhi.userHasFeature(this.$mhi.FEATURE1)).
 */

const UserHasFeature = {
	install: function(Vue) {
		// Install this as a global component
		Vue.component("feature", {
			functional: true,
			props: {
				id: {
					type: String,
					default: ""
				}
			},
			render(h, context) {
				const userHasFeature = context.parent.$store.getters[
					"currentUserHasFeature"
				](context.props.id);

				if (userHasFeature) {
					return context.children;
				} else {
					return null;
				}
			}
		});
	}
};

export default UserHasFeature;
